
exports.trim = function (val) {
    return val.replace(/(^\s*)|(\s*$)/g, "")
}

exports.ch = /^[\u4e00-\u9fa5A-Za-z]{0,30}$/;
exports.ac = /^[a-zA-Z0-9.]{0,19}[a-zA-Z0-9]$/;
exports.phone = /^(1[0-9])\d{9}$/;
exports.idcard = /^[a-zA-Z0-9]{18}$/;
exports.pEmail = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/;

exports.three = /([\w\W])\1{2}/;
exports.departmentId = /^\d{1,9}$/;

exports.four = /(0123|1234|2345|3456|4567|5678|6789|7890)/;
exports.fourR = /(9876|8765|7654|6543|5432|4321|3210)/;

exports.continuity = function (value) {
    let order = 0;
    let back = 0;
    for (let i = 1; i < value.length; i++) {
        if (value[i - 1].charCodeAt() - value[i].charCodeAt() == 1) {
            order++
        }
        else if (value[i].charCodeAt() - value[i - 1].charCodeAt() == 1) {
            back++
        }
        else {
            if (order >= 3 || back >= 3) {
                return true
            }
            order = 0;
            back = 0;
        }
    }
    return (order >= 3 || back >= 3)
}

exports.company = /(huolala|lalamove)/;

exports.psw = /^\s*(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{12,128}\s*$/;

exports.hideCode = function (str, start, end) {
    var len = end - start + 1
    var xing = '';
    for (var i = 0; i < len; i++) {
        xing += '*';
    }
    return str.substring(0, start) + xing + str.substring(end + 1, str.length);
};

